import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=ed0e08a4&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&lang=ts"
export * from "./DownloadButton.vue?vue&type=script&lang=ts"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=ed0e08a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0e08a4",
  null
  
)

export default component.exports